import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-xhr-backend";
import LanguageDetector from "i18next-browser-languagedetector";

export const AvailableLanguages = ["en", "de", "es", "fr", "ja", "pl", "ru"];

i18n
    // load translation using xhr -> see /public/locales
    // learn more: https://github.com/i18next/i18next-xhr-backend
    .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        fallbackLng: "en",
        debug: true,
        whitelist: AvailableLanguages,

        interpolation: {
            escapeValue: false // not needed for react as it escapes by default
        }
    });

export const getCurrentLanguage = () => {
    const language = i18n.language;
    return (
        AvailableLanguages.find(l => l === language || (language && language.indexOf(l) >= 0)) || AvailableLanguages[0]
    );
};

export default i18n;
